// Archivo generado automaticamente por scripts/generate-humor-manifest.cjs.
// No edites esta lista a mano: se ordena por fecha de creacion descendente.
export default [
    {
        "path": "sos-001.webp",
        "name": "sos-001.webp",
        "title": "Sos",
        "category": "sos",
        "createdAt": "2026-05-12T07:23:00.211Z",
        "modifiedAt": "2026-05-12T07:23:00.211Z",
        "size": 38888
    },
    {
        "path": "sos-002.webp",
        "name": "sos-002.webp",
        "title": "Sos",
        "category": "sos",
        "createdAt": "2026-05-12T07:23:00.211Z",
        "modifiedAt": "2026-05-12T07:23:00.211Z",
        "size": 79244
    },
    {
        "path": "sos-003.webp",
        "name": "sos-003.webp",
        "title": "Sos",
        "category": "sos",
        "createdAt": "2026-05-12T07:23:00.211Z",
        "modifiedAt": "2026-05-12T07:23:00.211Z",
        "size": 41478
    },
    {
        "path": "windows-001.webp",
        "name": "windows-001.webp",
        "title": "Windows",
        "category": "windows",
        "createdAt": "2026-05-12T07:23:00.211Z",
        "modifiedAt": "2026-05-12T07:23:00.211Z",
        "size": 109536
    },
    {
        "path": "python-002.webp",
        "name": "python-002.webp",
        "title": "Python",
        "category": "python",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.211Z",
        "size": 81188
    },
    {
        "path": "ia-001.webp",
        "name": "ia-001.webp",
        "title": "Ia",
        "category": "ia",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 79428
    },
    {
        "path": "informatica-001.webp",
        "name": "informatica-001.webp",
        "title": "Informatica",
        "category": "informatica",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 32772
    },
    {
        "path": "informatica-002.webp",
        "name": "informatica-002.webp",
        "title": "Informatica",
        "category": "informatica",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 56170
    },
    {
        "path": "informatica-003.webp",
        "name": "informatica-003.webp",
        "title": "Informatica",
        "category": "informatica",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 160908
    },
    {
        "path": "informatica-004.webp",
        "name": "informatica-004.webp",
        "title": "Informatica",
        "category": "informatica",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 67526
    },
    {
        "path": "java-001.webp",
        "name": "java-001.webp",
        "title": "Java",
        "category": "java",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 72100
    },
    {
        "path": "javascript-001.webp",
        "name": "javascript-001.webp",
        "title": "Javascript",
        "category": "javascript",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 75474
    },
    {
        "path": "lenguajes-001.webp",
        "name": "lenguajes-001.webp",
        "title": "Lenguajes",
        "category": "lenguajes",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 35228
    },
    {
        "path": "lenguajes-002.webp",
        "name": "lenguajes-002.webp",
        "title": "Lenguajes",
        "category": "lenguajes",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 55582
    },
    {
        "path": "programacion-001.webp",
        "name": "programacion-001.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 55926
    },
    {
        "path": "programacion-002.webp",
        "name": "programacion-002.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 71570
    },
    {
        "path": "programacion-003.webp",
        "name": "programacion-003.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 49066
    },
    {
        "path": "programacion-004.webp",
        "name": "programacion-004.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 70052
    },
    {
        "path": "programacion-005.webp",
        "name": "programacion-005.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 76150
    },
    {
        "path": "programacion-006.webp",
        "name": "programacion-006.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 49496
    },
    {
        "path": "programacion-007.webp",
        "name": "programacion-007.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 48918
    },
    {
        "path": "programacion-008.webp",
        "name": "programacion-008.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 64088
    },
    {
        "path": "programacion-009.webp",
        "name": "programacion-009.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 71548
    },
    {
        "path": "programacion-010.webp",
        "name": "programacion-010.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 134504
    },
    {
        "path": "programacion-011.webp",
        "name": "programacion-011.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 94400
    },
    {
        "path": "programacion-012.webp",
        "name": "programacion-012.webp",
        "title": "Programacion",
        "category": "programacion",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 54068
    },
    {
        "path": "python-001.webp",
        "name": "python-001.webp",
        "title": "Python",
        "category": "python",
        "createdAt": "2026-05-12T07:23:00.207Z",
        "modifiedAt": "2026-05-12T07:23:00.207Z",
        "size": 121036
    }
];
